<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_1"><span class="small">INTRODUCTION</span></a></h2><a id="page_1">
<p class="cep1">OUR ANGRY WORLD</p>
<p class="txba"><img alt="image" src="images/common.jpg"/></p>
<p class="cot">People are so angry today. They’re mad at what happened yesterday and bitter about things that occurred years ago. Perhaps you are angry with your spouse, a coworker, or a friend. The truth is, we all get mad at one time or another. The question we need to ask ourselves is, <em>How should we deal with anger in ourselves and respond to it in others?</em></p>
<p class="tx">Many people are angry and don’t even realize it. They just know something’s not right on the inside. What they need is to be set free from the bondage of bitterness and resentment.</p>
<p class="tx">Then there are those who know they’re angry and just don’t care. These people nurture their anger. They cultivate and feed it, keeping hostility and hatred simmering for years.</p>
<p class="tx">Countless people have lost their marriages because of anger. They’ve lost their children, their jobs, and their health—all because they let this one emotion get out of control and take over their entire lives.</p>
<p class="tx">We live in an angry world. Like a windswept wildfire, anger leaves scorched lives and devastating loss in its wake. This emotion reaches into our families, our neighborhoods, our communities, across our nation, and around the world.</p>
</a><p class="tx"><a id="page_1">If we’re honest, many of us will admit to feeling a degree of anger deep inside that is greater these days than we have felt before. It’s not a question of <em>if</em> we’ve ever been angry—all of us have been angry at one time or another. And there’s no way to guarantee we’ll </a><a id="page_2">never get angry again. But the Bible gives us very clear instruction regarding how we should handle this powerful and potentially damaging emotion.</a></p><a id="page_2">
<p class="tx">Anger in itself is not necessarily evil or destructive. There’s good anger and there’s bad anger. The problem is that most people have more experience with bad anger than with good anger.</p>
<p class="tx">So let me ask you a question: Are you angry?</p>
<p class="tx">And if you are, do you know why?</p>
<p class="tx">As we are about to discover, anger can be a very dangerous thing.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Intro.vue?64524bf0